import type { NskResponse } from "~/models/Api";
import type {
	VendorCompanyUpdatePasswordParam,
	VendorCompanyUpdateSelfParams
} from "~/models/VendorCompany";
import { postRequest, putRequest } from "~/utils/api/api_handler";

const paths = {
	changePassword: "/vendors/vendor_companies/change_password",
	updateSelf: "/vendors/vendor_companies/update_self"
};

export const updateSelf = async (
	vendorCompany: VendorCompanyUpdateSelfParams
): Promise<NskResponse> => putRequest(paths.updateSelf, { vendorCompany });

export const changePassword = async (
	passwords: VendorCompanyUpdatePasswordParam
): Promise<NskResponse> => postRequest(paths.changePassword, passwords);
